module.exports = __webpack_public_path__ + "static/media/ncbr.242d3b01.svg";